<template>
    <div ref="countdown" class="countdown">
        <span class="countdown__number">{{ countdownNumber }}</span>
        <svg class="countdown__icon" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 130 130" overflow="visible" enable-background="new 0 0 130 130">
            <path ref="circleBorder" class="countdown__icon__circle" d="M5,64.8a59.8,59.8 0 1,0 119.6,0a59.8,59.8 0 1,0 -119.6,0"/>
        </svg>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';

export default {
    props: {
        duration: 0
    },

    computed: {
        ...mapFields({
            recordingDuration: 'recordingDuration'
        }),

    },

    data() {
        return {
            countdownNumber: 0
        }
    },

    mounted() {
        this.countdownNumber = this.duration;
        const countdown = this.$refs.countdown;
        const circleBorder = this.$refs.circleBorder;
        const circleLength = circleBorder.getTotalLength();

        // transform countdown size on start
        // new TweenMax(countdown, 0, {scale: 0});
        // TweenMax.to(countdown, .5, {scale: 1, ease: Back.easeOut.config(1.4)});

        // transform stroke color
        new TweenMax(circleBorder, this.duration, {
            strokeDashoffset: circleLength,
            stroke: '#bc6c25',
            ease: Power0.easeNone
        });
    },

    methods: {
        convertDurationToInt(duration) {
            return parseInt(duration * -1)
        }
    },

    watch: {
        recordingDuration() {
            this.countdownNumber = this.convertDurationToInt(this.recordingDuration);
        }
    }
}
</script>
